import { signinRoute } from './signin';

export const allSigninRoutes = [signinRoute()];
